// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608271222/js/" + chunkId + "." + {"44":"eabbfd10","225":"562649a9","481":"0a0bdafd","486":"0234fcd7","770":"e7864f6b"}[chunkId] + ".0.5393686071906619.chunk.js";
};